import AuthGuest from "../AuthGuest"
import { API_PUBLIC } from "@/app/contants/url"

const ProjectService = {
  getList: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}projects`, {params}),
  getTypesList: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}projects/types`, {params}),
  getDetails: (id: string): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}projects/${id}`),
}
export default ProjectService
